import React from 'react';
import { Redirect } from 'react-router-dom';

// Dashboard
import { DashboardRoutes } from '../modules/dashboard';

//login
import ForgetPasswordPage from '../modules/Authentication/ForgetPassword';
import Register from '../modules/Authentication/Register';
import TypeNotes from '../modules/TypeNotes';
import { SellersRoutes } from '../modules/sellers';
import { OfficesRoutes } from '../modules/Offices';
import { CategoriesFinanceRoutes } from '../modules/CategoriesFinance';
import { ProposalsRoutes } from '../modules/proposals';
import CategoryOrganizations from '../modules/CategoryOrganizations';
import Units from '../modules/Units';
import Specialties from '../modules/Specialties';
import UserScreen from '../modules/Users';
import FormUsers from '../modules/Users/FormUsers';
import { CredentialsNTRoutes } from '../modules/CredentialsNT';
import NotFound from '../modules/NotFound';
import { AssociatesRoutes } from '../modules/associates';
import { PlansRoutes } from '../modules/plans';
import { CategoriesPlansRoutes } from '../modules/CategoriesPlans';
import { AuthRoutes } from '../modules/auth';
import { ReportsRoutes } from '../modules/reports';
import { ProfileRoutes } from '../modules/profile';
import { AccountsRoutes } from '../modules/accounts';
import { CostCenterRoutes } from '../modules/CostCenter';
import { SupplierRoutes } from '../modules/Suppliers';
import { ServicesRoutes } from '../modules/Services';
import { ChangeMonthlyPayment } from '../modules/ChangeMonthlyPayment';
import { BillsToPayRoutes } from '../modules/billsToPay';
import { OrganizationsRoutes } from '../modules/Organizations';
import { BillsToRecieveRoutes } from '../modules/billsToRecive';
import { ValidationOfProposalsRoutes } from '../modules/ValidationOfProposals';
import { WhatsappRoutes } from '../modules/Whatsapp';

const authProtectedRoutes = [
  ...DashboardRoutes,
  ...AssociatesRoutes,
  ...SupplierRoutes,
  ...PlansRoutes,
  ...ProposalsRoutes,
  ...CategoriesPlansRoutes,
  ...CategoriesFinanceRoutes,
  ...ReportsRoutes,
  ...CredentialsNTRoutes,
  ...ProfileRoutes,
  ...AccountsRoutes,
  ...CostCenterRoutes,
  ...ServicesRoutes,
  ...BillsToPayRoutes,
  ...ChangeMonthlyPayment,
  ...OrganizationsRoutes,
  ...OfficesRoutes,
  ...SellersRoutes,
  ...BillsToRecieveRoutes,
  ...ValidationOfProposalsRoutes,
  ...WhatsappRoutes,

  {
    path: '/configuracoes/tabelas/tipos-notas-associados',
    component: TypeNotes,
  },
  {
    path: '/configuracoes/tabelas/categorias-organizacoes',
    component: CategoryOrganizations,
  },
  {
    path: '/unidades',
    component: Units,
  },
  {
    path: '/especialidades',
    component: Specialties,
  },
  {
    path: '/configuracoes/usuarios',
    component: UserScreen,
  },
  {
    path: '/configuracoes/usuarios/novo',
    component: FormUsers,
  },
  {
    path: '/configuracoes/usuarios/edit/:id',
    component: FormUsers,
  },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/overview" />,
  },
  {
    path: '*',
    exact: true,
    component: NotFound,
  },
];

const publicRoutes = [
  ...AuthRoutes,
  { path: '/forgot-password', component: ForgetPasswordPage },
  { path: '/register', component: Register },
];

export { authProtectedRoutes, publicRoutes };
